import React from 'react';
import { Col, Row } from 'react-bootstrap5';

import ChooseEnterprise from 'components/Managers/ChooseEnterprise/Index';

export default function Index() {
  return (
    <section>
      <Row className="mb-3">
        <Col>
          <h1>Talent Index</h1>
        </Col>
        <Col className="text-end">
          <ChooseEnterprise />
        </Col>
      </Row>
    </section>
  );
}
